<template>
  <header class="main-header">
        <div href="#" class="logo">
      <span class="logo-mini logo-mini-container">
        <div class="d-flex d-sm-none">
          <form
            class="logo-mini-custom-invite"
            v-if="$store.getters.currentUser.active"
          >
            <div class="container">
              <div class="input-group">
                <span class="input-group-addon"
                  ><i class="icon-plane text-white"></i></span
                ><input
                  type="text"
                  class="form-control"
                  :value="
                    this.domain +
                      '/#/register/lineBy/' +
                      $store.getters.currentUser.username +
                      '/branch/' +
                      (($store.getters.currentUser.right && 'right') || 'left')
                  "
                  v-clipboard:copy="
                    this.domain +
                      '/#/register/lineBy/' +
                      $store.getters.currentUser.username +
                      '/branch/' +
                      (($store.getters.currentUser.right && 'right') || 'left')
                  "
                  v-clipboard:success="onCopy"
                />
              </div>
            </div>
          </form>
        </div>
      </span>
      <span class="logo-lg"> </span>
    </div>
    <nav class="navbar navbar-static-top">
      <a
        href="#"
        id="toggle-menu"
        class="sidebar-toggle "
        data-toggle="push-menu"
        role="button"
      >
        <span class="sr-only">Toggle navigation</span>
      </a>

      <div class="navbar-custom-translate translate-menu d-none d-sm-flex">
        <GoogleTranslate id="goog-translate" />
      </div>

      <div class="navbar-custom-invite">
        <form class="d-none d-sm-flex" v-if="$store.getters.currentUser.active">
          <div class="container">
            <div class="input-group">
              <span class="input-group-addon"
                ><i class="icon-plane text-white"></i
              ></span>
              <input
                type="text"
                class="form-control"
                :value="
                  this.domain +
                    '/#/register/lineBy/' +
                    $store.getters.currentUser.username +
                    '/branch/' +
                    (($store.getters.currentUser.right && 'right') || 'left')
                "
                v-clipboard:copy="
                  this.domain +
                    '/#/register/lineBy/' +
                    $store.getters.currentUser.username +
                    '/branch/' +
                    (($store.getters.currentUser.right && 'right') || 'left')
                "
                v-clipboard:success="onCopy"
              />
            </div>
          </div>
        </form>
      </div>

      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">
          <li class="dropdown notifications-menu">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <i class="mdi mdi-bell"></i>
            </a>
            <ul class="dropdown-menu scale-up">
              <li class="header">You have no notifications</li>
              <li>
                <ul class="menu inner-content-div"></ul>
              </li>
              <li class="footer">
                <a href="#">View all</a>
              </li>
            </ul>
          </li>

          <li class="dropdown user user-menu">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <img
                :src="$store.getters.currentUser.avatar"
                class="user-image rounded-circle"
                alt="User Image"
              />
            </a>
            <ul class="dropdown-menu scale-up">
              <li class="user-header">
                <img
                  :src="$store.getters.currentUser.avatar"
                  class="float-left rounded-circle avatar"
                  alt="User Image"
                />
                <p>
                  {{ $store.getters.currentUser.username }}
                  <small class="mb-5">{{
                    $store.getters.currentUser.email
                  }}</small>
                </p>
              </li>
              <li class="user-body">
                <div class="row no-gutters">
                  <div class="col-12 text-left">
                    <router-link to="/profile">
                      <i class="ion ion-person"></i> My Profile
                    </router-link>
                  </div>

                  <div role="separator" class="divider col-12"></div>
                  <div class="col-12 text-left">
                    <a href="#" @click="logout">
                      <i class="fa fa-power-off"></i> Logout
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<style lang="scss" scoped>
.navbar {
  &-static {
    &-top {
      display: flex;
      justify-content: space-between;
    }
  }
  &-custom {
    &-translate {
      width: 20%;
    }
    &-invite {
      width: 50%;
      .container {
        width: 100%;
      }
    }
    &-menu {
      display: flex;
      align-items: center;
      justify-content: space-evenly;
    }
  }
}
.user-menu {
  .avatar {
    width: 6rem !important;
    height: 6rem !important;
  }
}
.logo-mini {
  &-container {
    width: 100%;
  }
  &-custom {
    &-invite {
      width: 100%;
    }
  }
}
</style>

<script>
import GoogleTranslate from "@/components/GoogleTranslate.vue";
import { userMixin } from "@/mixins";

export default {
  name: "top-menu",
  components: {
    GoogleTranslate
  },
  data() {
    return {
      model: {},
      domain: ""
    };
  },
  mixins: [userMixin],
  methods: {
    swapLeg(leg) {
      leg = leg === "left" ? false : true;
      this.loading = true;
      this.$http({
        method: "put",
        url: "/api/v1/client/users/" + this.$store.getters.currentUser.uuid,
        data: { right: leg },
        headers: {
          "content-type": "application/json",
          Authorization: this.$store.getters.authToken
        }
      })
        .then((response) => {
          this.$store.commit("setCurrentUser", response.data);
          this.loading = false;
          this.$toasted.show("Information updated!", {
            position: "top-right",
            duration: 5000,
            type: "success",
            closeOnSwipe: true
          });
        })
        .catch((error) => {
          error.response.data &&
            error.response.data.map((m) => {
              this.$toasted.show(m, {
                position: "top-right",
                duration: 5000,
                type: "error",
                closeOnSwipe: true
              });
            });
          this.loading = false;
        });
    },
    onCopy() {
      this.$toasted.show("Copied to clippboard!", {
        position: "top-right",
        duration: 5000,
        type: "success",
        closeOnSwipe: true
      });
    }
  },

  created() {
    this.domain = process.env.VUE_APP_ROOT_DOMAIN;
  }
};
</script>
